__turbopack_context__.v({
  "article-header": "yQOpcG_article-header",
  "button-share": "yQOpcG_button-share",
  "meta-container": "yQOpcG_meta-container",
  "socials-container": "yQOpcG_socials-container",
});
